import React, { useState } from 'react';

export interface AddToHomeModalProps {
  isOpen: boolean;
  onClose: (rememberHide: boolean) => void;
}

/**
 * iOS Safari ユーザー向けに「ホーム画面に追加」の手順を案内する presentational モーダル。
 * 表示判定は呼び出し側 (useAddToHomePrompt) で行い、このコンポーネントは UI のみを担う。
 */
const AddToHomeModal: React.FC<AddToHomeModalProps> = ({ isOpen, onClose }) => {
  const [rememberHide, setRememberHide] = useState(false);

  if (!isOpen) return null;

  const handleClose = () => onClose(rememberHide);

  return (
    <div
      data-testid="add-to-home-overlay"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      onClick={handleClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="add-to-home-title"
        className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="add-to-home-title" className="mb-3 text-lg font-bold text-amber-800">
          📱 ホーム画面に追加すると便利！
        </h2>
        <p className="mb-4 text-sm text-gray-600">
          1 タップでアプリのように起動できます。
        </p>
        <ol className="mb-5 space-y-2 text-sm text-gray-800">
          <li>
            <span className="mr-2 inline-block font-bold text-amber-600">①</span>
            画面下部の <span className="font-bold">共有</span> ボタン (□に↑のアイコン) をタップ
          </li>
          <li>
            <span className="mr-2 inline-block font-bold text-amber-600">②</span>
            メニューをスクロールして「ホーム画面に追加」を選択
          </li>
          <li>
            <span className="mr-2 inline-block font-bold text-amber-600">③</span>
            右上の <span className="font-bold">「追加」</span> をタップ
          </li>
        </ol>
        <label className="mb-4 flex items-center gap-2 text-sm text-gray-700">
          <input
            type="checkbox"
            checked={rememberHide}
            onChange={(e) => setRememberHide(e.target.checked)}
            className="h-4 w-4 rounded border-gray-300 text-amber-600 focus:ring-amber-500"
          />
          今後表示しない
        </label>
        <button
          type="button"
          onClick={handleClose}
          className="w-full rounded-lg bg-amber-600 px-4 py-2 text-sm font-bold text-white hover:bg-amber-700"
        >
          閉じる
        </button>
      </div>
    </div>
  );
};

export default AddToHomeModal;
